import React, { useEffect, useState } from "react";
import { Typography, Box, ThemeProvider } from "@mui/material";

import { useTokenStore } from "../Zustand/TokenStore";
import theme from "../theme";

interface HeaderProps {
  title: string;
  subtitle?: string;
  PageId?: number;
}

const Header: React.FC<HeaderProps> = ({ title, subtitle, PageId }) => {
  const [pageName, setPageName] = useState<string | null>(null);

  const findPageName = (PageId: number) => {
    const userData = useTokenStore.getState().AuthData;
    let found = false;

    userData.Modules.forEach((module) => {
      module.Submodules.forEach((submodule) => {
        submodule.Pages.forEach((page) => {
          if (page.Page_Id === PageId) {
            setPageName(page.Page_Name);
            found = true;
            return;
          }
        });
      });

      // Check if the page is already found to exit the loop
      if (found) return;

      module.Pages.forEach((page) => {
        if (page.Page_Id === PageId) {
          setPageName(page.Page_Name);
          found = true;
          return;
        }
      });
    });

    if (!found) {
      setPageName(null); // If the PageId is not found, set pageName to null
    }
  };

  useEffect(() => {
    if (PageId) {
      findPageName(PageId);
    }
  }, [PageId]);

  return (
    <ThemeProvider theme={theme}>
      <Box>
        <Typography variant="h5" fontWeight="bold" color={theme.palette.primary.main}>
          {pageName || title}
        </Typography>
        {subtitle && (
          <Typography variant="h5" color={theme.palette.primary.main}>
            {subtitle}
          </Typography>
        )}
      </Box>
    </ThemeProvider>
  );
};

export default Header;
